import hasWhitespacesOnly from './common/hasWhitespacesOnly';
import incorrectDataType from './common/incorrectDataType';
import isEmpty from './common/isEmpty';
import isNull from './common/isNull';
import isUndefined from './common/isUndefined';

export const isValidName = (name) => {
  if (
    isNull(name) ||
    isUndefined(name) ||
    incorrectDataType(name, 'string') ||
    hasWhitespacesOnly(name) ||
    isEmpty(name)
  ) {
    return false;
  } else {
    return name !== '' && String(name).length > 0 && String(name).length <= 150;
  }
};

export const filterName = (name) => {
  return name.replace(/[^-.a-zA-Z\s]/g, '');
};
